import React, { HTMLProps } from "react";
import classnames from "classnames";
import { Element } from "../base";
import { twMerge } from "tailwind-merge";

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    title?: string;
    children: React.ReactNode;
    active?: boolean;
}

function MenuListItem(props: IProps) {
    const { className, title, active, children, ...rest } = props;
    return (
        <Element
            renderAs="li"
            className={twMerge(
                "block mb-0 p-0",
                className,
                classnames({
                    "is-active": active,
                })
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default MenuListItem;
